var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('p',[_vm._v(" An error occurred while fetching content: "),_c('span',{staticStyle:{"color":"tomato"}},[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }